// extracted by mini-css-extract-plugin
export default {"modalContainer":"mx","fadeRight":"nx","fadeUp":"ox","topShelf":"px","newFlavorBadge":"qx","transparentText":"rx","cancelButton":"sx","invisibleLink":"tx","closeIcon":"ux","linkContainer":"vx","hed":"wx","image":"xx"};
    if(module.hot) {
      // 1738064238383
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  